import { useMemo } from 'react';
import {
    useAddUserMutation,
    useGetRolesQuery,
    useLazyGetPermissionsByRoleIdQuery,
    useLazyGetUserByIdQuery,
    useLazyUserCuilValidationQuery,
    useUpdateUserMutation
} from '../../../../../services/adminApi';
import { useGetAllDocumentTypesQuery } from '../../../../../services/documentsApi';

function useFetchs({ drawerAction, userCuilState }: any) {
    const [addUser, { isLoading: addingUser }] = useAddUserMutation();
    const [updateUser, { isLoading: updatingUser }] = useUpdateUserMutation();
    const [getUserById, { isLoading: loadingUserById, isFetching: fetchingUserById }] =
        useLazyGetUserByIdQuery();
    const [
        validateUserCuil,
        { isLoading: loadingUserCuilValidation, isFetching: fetchingUserCuilValidation }
    ] = useLazyUserCuilValidationQuery();

    const {
        data: roles,
        isLoading: loadingRoles,
        isFetching: fetchingRoles
    } = useGetRolesQuery(
        {},
        {
            refetchOnMountOrArgChange: false,
            skip:
                (drawerAction === 'new' && userCuilState?.state !== 'ok') ||
                (!['new', 'edit'].includes(drawerAction) && userCuilState?.state !== 'ok')
        }
    );
    const {
        data: allDocumentTypes,
        isLoading: loadingAllDocumentTypes,
        isFetching: fetchingAllDocumentTypes
    } = useGetAllDocumentTypesQuery(
        {},
        {
            refetchOnMountOrArgChange: false,
            skip:
                (drawerAction === 'new' && userCuilState?.state !== 'ok') ||
                !['new', 'edit'].includes(drawerAction)
        }
    );
    const [
        getPermissionsByRoleId,
        { isLoading: loadingRolePermissions, isFetching: fetchingRolePermissions }
    ] = useLazyGetPermissionsByRoleIdQuery();

    const validatingUserCuil = useMemo(() => {
        return loadingUserCuilValidation || fetchingUserCuilValidation;
    }, [loadingUserCuilValidation, fetchingUserCuilValidation]);

    return {
        validateUserCuil,
        addUser,
        getPermissionsByRoleId,
        updateUser,
        updatingUser,
        loadingRolePermissions,
        fetchingRolePermissions,
        addingUser,
        allDocumentTypes,
        loadingAllDocumentTypes,
        fetchingAllDocumentTypes,
        roles,
        getUserById,
        loadingRoles,
        fetchingRoles,
        validatingUserCuil,
        loadingUserCuilValidation,
        fetchingUserCuilValidation,
        loadingUserById,
        fetchingUserById
    };
}

export default useFetchs;
